/**
 * The product's name, as every surface displays it.
 *
 * One copy. The API's documents and messages import it from here; the web
 * apps read the same object through `@dru/types`, which re-exports this file
 * (the API compiles with tsc and `rootDir: src`, so it cannot import a
 * workspace package — the copy lives on this side and the SPA reads it, as
 * `@dru/clinical-math` does). Dependency-free on purpose: it is compiled into
 * CommonJS here and bundled as ESM there.
 *
 * Display text only. Domains, env var names, technical ids (`dr-ultimate`,
 * the problem-type URIs), stored rows and documents already issued are not
 * the brand and do not change with it.
 */
export const BRAND = {
  /** The name, everywhere it stands alone: "Welcome to Dr Ultimate". */
  name: 'Dr Ultimate',
  /** The descriptor that follows the name in its longer form. */
  tagline: 'Industrial Healthcare',
  /** Letterheads, email signatures, the sender's name, the © line. */
  longName: 'Dr Ultimate Industrial Healthcare',
  /**
   * A contextual subtitle for the camp and hospital surfaces. Optional:
   * use it where the screen is about checkups, not as a general suffix.
   */
  subtitle: 'Camp & Hospital Checkups',
  /**
   * The approved artwork. Paths are the web apps' `public/` files; the API's
   * PDFs and emails embed `certificate/services/brand-logo.ts`, generated from
   * the same `logo.png`.
   */
  logo: {
    /** The full lockup: mark and wordmark. */
    full: '/logo.png',
    /** The mark alone, square. */
    mark: '/mark.png',
    favicon: '/favicon.png',
    /** Alt text for the full lockup. */
    alt: 'Dr Ultimate — Industrial Healthcare',
    /** Alt text for the mark alone. */
    markAlt: 'Dr Ultimate',
  },
  /** The support address used until an operator sets one in Settings. */
  defaultSupportEmail: 'support@drultimate.com',
} as const;

export type Brand = typeof BRAND;
